import { useParams } from 'react-router';

import { appendAccessToken } from 'src/utils/appendAccessToken';

const ProjectCriteriaEvaluationPage = () => {
    const params = useParams();
    const { id } = params;
    window.location.replace(
        appendAccessToken(`${window.APADUA_SOURCE}app/rfp/${id}/criteria_evaluation`),
    );

    return null;
};

export default ProjectCriteriaEvaluationPage;
